import _ from 'underscore'

export function CSVExportTrial(results, trialId, projectId) {
    let csvContent = transformResultsToCSVRows(results)
    generateCSVFromContent(csvContent, 'AlyaResults_project_' + projectId +'_trial_' + trialId)
}

export function CSVExportProject(results, projectId) {
    let csvContent = transformResultsToCSVRows(results)
    generateCSVFromContent(csvContent, 'AlyaResults_project_' + projectId)
}

export function CSVExportGroup(results, groupInfo, projectId) {
    results.filter(result => {
        let isSubjectInGroup = (idInGroup) => idInGroup == result.subject.id
        return groupInfo.subjectIds.some(isSubjectInGroup)
    })
    let csvContent = transformResultsToCSVRows(results)
    generateCSVFromContent(csvContent, 'AlyaResults_project_' + projectId +'_group_' + groupInfo.name)
}

function transformResultsToCSVRows(filteredResults) {
    let projectTags = filteredResults[0].tags.map(tag => tag.name)
    let projectScalars = filteredResults[0].scalars.map(scalar => scalar.name)
    let headersRow = ["Subject", "Trial", projectTags.flat(), projectScalars.flat()]
    let dataRows= []
    filteredResults.forEach((result) => {
        let tagValues = result.tags.map(tag => tag.value)
        let scalarValues = result.scalars.map(scalar => scalar.value)
        let csvValuesRow = _.flatten([result.subject.templateId, result.trialId, tagValues.flat(), scalarValues.flat()])
        dataRows.push(csvValuesRow)
    })
    let flatHeadersRow  = _.flatten(headersRow)
    dataRows.unshift(flatHeadersRow)
    let csvUniqueRows = removeDuplicateColumns(flatHeadersRow, dataRows)
    return "data:text/csv;charset=utf-8," + csvUniqueRows.map(row => row.join(",")).join("\n");
   
}

function removeDuplicateColumns(headersRow, csvRows) {
  let headerPositions = {};
  headersRow.forEach((header, position) => {
    headerPositions[header] = headerPositions[header] || [];
    headerPositions[header].push(position);
  });
  Object.keys(headerPositions).forEach((header) => {
    let thisHeaderPositions = headerPositions[header];
    if (thisHeaderPositions.length > 1) {
        for (let nextDup = 1; nextDup < thisHeaderPositions.length; nextDup ++)
            csvRows.forEach(row => row.splice(thisHeaderPositions[nextDup], 1))
    }
  });
  return csvRows
}

function generateCSVFromContent(content, fileName) {
    let encodedUri = encodeURI(content)
    let link = document.createElement("a")
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName + ".csv");
    document.body.appendChild(link);
    link.click();
}